import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2, Flame } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = loc.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login");
      return;
    }
    const sid = match[1];
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data.user);
        // Clear hash and redirect
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        nav("/login");
      }
    })();
  }, [loc, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass p-8 rounded-lg flex items-center gap-4">
        <Flame className="w-6 h-6 text-orange-500" strokeWidth={2.5} />
        <Loader2 className="w-5 h-5 animate-spin text-pink-500" strokeWidth={2.5} />
        <span className="text-sm text-gray-600">Authenticating with Fire360Pro…</span>
      </div>
    </div>
  );
}
